import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

const STORAGE_KEY = 'evoluxu_cart_v1'

export const useCartStore = defineStore('cart', () => {
  const items = ref([])

  function load() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (raw) items.value = JSON.parse(raw) || []
    } catch { items.value = [] }
  }
  function persist() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items.value)) } catch {}
  }

  function add(item) {
    const existing = items.value.find((i) => i.id === item.id && i.kind === item.kind)
    if (existing) existing.qty += item.qty || 1
    else items.value.push({ ...item, qty: item.qty || 1 })
    persist()
  }

  function remove(id, kind) {
    items.value = items.value.filter((i) => !(i.id === id && i.kind === kind))
    persist()
  }

  function setQty(id, kind, qty) {
    const it = items.value.find((i) => i.id === id && i.kind === kind)
    if (!it) return
    it.qty = Math.max(1, qty | 0)
    persist()
  }

  function clear() { items.value = []; persist() }

  const count = computed(() => items.value.reduce((a, i) => a + i.qty, 0))
  const total = computed(() => items.value.reduce((a, i) => a + (i.price || 0) * i.qty, 0))

  load()
  return { items, count, total, add, remove, setQty, clear }
})
